<template>
  <div>
    <CommonSection />
    <div class="container-fluid">
      <div class="row mt-4">
        <div class="col">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <h3 class="mb-0 float-left card-header-name">{{(isEdit) ? 'Edit' : 'Add'}} Community</h3>
            </div>
            <v-stepper v-model="e1" light>
              <v-stepper-header>
                <v-stepper-step :complete="e1 > 1" step="1" editable>Community Details</v-stepper-step>
                <!-- <v-stepper-step v-if="isEdit" :complete="e1 > 1" step="1" editable>Community Details</v-stepper-step> -->
                <v-divider></v-divider>
                <v-stepper-step v-if="!isEdit" :complete="e1 > 2" step="2">Community Image</v-stepper-step>
                <v-stepper-step v-if="isEdit" :complete="e1 > 2" step="2"  @click="validateUpdate" editable>Community Image</v-stepper-step>
              </v-stepper-header>

              <v-stepper-items>
                <v-stepper-content class="v-form-body" step="1">
                  <v-form ref="form" v-model="valid" lazy-validation enctype="multipart/form-data">
                    <v-row>
                      <v-col cols="12">
                        <label class="form-control-label">Community Name
                          <span class="red--text">*</span>
                        </label>
                        <v-text-field
                          v-model="community.title"
                          placeholder="Enter Community Name"
                          :rules="[(v) => !!v || 'Community Name is required!',(v) => v && !!v.trim() || 'Field cannot be blank']"
                          required
                          solo
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <label class="form-control-label">Community Description
                          <span class="red--text">*</span>
                        </label>
                        <v-textarea
                          v-model="community.description"
                          solo
                          label="Short description"
                          auto-grow
                          :rules="[(v) => !!v || 'Description is required!',(v) => v && !!v.trim() || 'Field cannot be blank']"
                          rows="5"
                        ></v-textarea>
                      </v-col>
                        <v-col cols="12">
                          <label class="form-control-label">Community Group Name
                            <span class="red--text">*</span>
                          </label>
                          <v-text-field
                            v-model="communityGroup.name"
                            placeholder="Enter Group Name"
                            :rules="[(v) => !!v || 'Group Name is required!',(v) => v && !!v.trim() || 'Field cannot be blank']"
                            required
                            solo
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" class="permissions-combobox">
                          <label class="form-control-label">
                           Community Chat Members
                          </label>
                          <v-combobox
                            v-model="communityGroup.users"
                            :items="usersList"
                            :item-text="item => item.firstName + ' ' + item.lastName"
                            item-value="_id"
                            label="Select Members"
                            multiple
                            solo
                            small-chips
                            clearable
                            hide-details
                            :loading="usersListLoading"
                          >
                            <template v-slot:prepend-item>
                              <v-list-item>
                                <v-list-item-action>
                                  <v-checkbox
                                    v-model="selected"
                                    hide-details
                                    @change="selectAllUsers"
                                    class="ma-0"
                                  />
                                </v-list-item-action>
                                <v-list-item-content>
                                  <v-list-item-title>Select All</v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </template>
                          </v-combobox>
                        </v-col>
                      <v-col class="text-right" cols="12">
                        <v-btn color="#989898" class="mr-4 white--text" @click="cancel">Cancel</v-btn>
                        <v-btn
                          v-if="!isEdit"
                          :disabled="!valid"
                          :loading="loading"
                          color="#344452"
                          class="white--text"
                          @click="validateSave"
                        >Next</v-btn>
                        <v-btn
                          v-if="isEdit"
                          :disabled="!valid"
                          :loading="loading"
                          color="#344452"
                          class="white--text"
                          @click="validateUpdate"
                        >Next & Update</v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-stepper-content>

                <v-stepper-content class="v-form-body" step="2">
                  <v-row>
                    <v-col :class="$vuetify.breakpoint.mdAndUp ? 'col-6' : 'col-12'" class="pa-5">
                      <v-card>
                        <v-card-title>
                          <span class="Subtitle 1">Upload Community Image</span>
                        </v-card-title>
                        <v-card-text>
                          <vue-dropzone
                            class="vue-dropzone-box"
                            ref="myVueDropzone"
                            id="dropzone"
                            :destroyDropzone="false"
                            :options="dropzoneOptions"
                            @vdropzone-sending="beforecomplete"
                            @vdropzone-success="aftercomplete"
                            @vdropzone-mounted="uploadedImage"
                            @vdropzone-removed-file="removeFile"
                            :useCustomSlot="true"
                            :useCustomDropzoneOptions="true"
                          >
                            <div class="dropzone-custom-content">
                              <img src="@/assets/images/ImageUpload.svg" />
                              <h3 class="font-weight-light ma-0">Drag and drop here to upload</h3>
                              <h3 class="font-weight-light ma-0">Or</h3>
                              <h3 class="dropzone-custom-title">Browse</h3>
                            </div>
                          </vue-dropzone>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-col class="text-right" cols="12">
                    <v-btn color="#989898" class="mr-4 white--text" @click="cancel">Cancel</v-btn>
                    <v-btn
                      :disabled="!valid"
                      color="#344452"
                      class="white--text"
                      :loading="loading"
                      @click="saveAndNext"
                    >Save</v-btn>
                  </v-col>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import CommonSection from "@/components/CommonHeader";
import { MediaService, CommunityService } from "@/services";
import vue2Dropzone from "vue2-dropzone";
import { MEDIATYPE_THUMBNAIL, CLINIC_IMAGE_WIDTH, CLINIC_IMAGE_HEIGHT} from "@/constants";
import { ImageValidateMixin } from "@/mixins";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { mapGetters } from 'vuex';

export default {
  name: "AddCommunity",
  components: {
    CommonSection,
    vueDropzone: vue2Dropzone,
  },
  mixins: [ImageValidateMixin],
  data() {
    var self = this;
    return {
      e1: 1,
      loading: false,
      valid: true,
      communityId: null,
      community: {
        title: null,
        description: null,
      },
      media: [],
      isEdit : false,
      dropzoneOptions: {
        url: `${process.env.VUE_APP_SERVERURL}media`,
        chunking: true,
        addRemoveLinks: true,
        autoProcessQueue: true,
        maxFilesize: 2, // MB
        thumbnailWidth: 300,
        maxFiles: 1,
        dictFileTooBig:"File is too big ({{filesize}}MB). Max filesize: {{maxFilesize}}MB.",
        headers: {
          Authorization: `Bearer ${store.state.user.token}`,
        },
        acceptedFiles: "image/*",
          init() {
          this.on("maxfilesexceeded", function(file) {
            this.removeAllFiles();
            this.addFile(file);
          });
          this.on("addedfile", file => {
            if (file.size > 1024 * 1024 * 2) {
              // not more than 2mb
              this.removeFile(file);
            }
          });
            this.on("thumbnail",(file) => {
              self.validateBannerDimension(file,CLINIC_IMAGE_WIDTH, CLINIC_IMAGE_HEIGHT)
            });
          },
          accept(file, done) {
            self.showError(file,CLINIC_IMAGE_WIDTH, CLINIC_IMAGE_HEIGHT, done)
          }
      },
      communityGroup: {
        name: null,
        users: [],
      },
      usersList: [],
      usersListLoading: false,
      selected: false,
      page: 1,
      perPage: 1000,
    };
  },
  computed: {
    ...mapGetters('user', {
      user: 'user',
    }),
  },
  created() {
    this.initialize();
  },
  mounted() {
  },
  watch: {
    "communityGroup.users": function (values) {
      this.selected =
        this.usersList.length == values.length ? true : false;
    },
  },
  async beforeMount() {
    this.getAllUsers();
  },
  methods: {
    async initialize() {
      if (this.$route.params.id !== 'create') {
        await this.getCommunityData();
        await this.uploadedImage();
        this.isEdit = true;
      }
    },
    async getCommunityData() {
      const communityDetail = await CommunityService.get(this.$route.params.id);
      const communityGroupDetail = await CommunityService.getGroup(this.$route.params.id);
      this.community.title = communityDetail.data.data[0].title;
      this.community.description = communityDetail.data.data[0].description;
      this.media = communityDetail.data.data[0].media;
      if (communityGroupDetail && communityGroupDetail.data.data.length > 0) {
        this.communityGroup.roomId = communityGroupDetail.data.data[0]._id;
        this.communityGroup.name = communityGroupDetail.data.data[0].name;
        this.communityGroup.users = communityGroupDetail.data.data[0].users;
      }
    },
    async getMedia() {
      const existingMedia = await CommunityService.get(this.communityId);
      this.media = existingMedia.data.data[0].media;
    },
    beforecomplete(file, xhr, formData) {
      formData.append("mediaType", "image");
      formData.append("moduleType", "channels");
      formData.append("mediaSubType", "file");
      formData.append("imageType", MEDIATYPE_THUMBNAIL);
      formData.append("moduleId", this.communityId);
    },
    aftercomplete(file) {
      this.$store.dispatch(
        "user/setSnack",
        "Community image uploaded successfully!"
      );
      this.getMedia();
      this.$store.dispatch("user/setType", "info");
    },
    uploadedImage() {
      if (this.media && this.media.length > 0) {
        this.media.filter((media) => {
          if (media.mediaType == "image") {
            var file = {
              size: media.size,
              name: media.name,
              type: media.type,
            };
            this.$refs.myVueDropzone.manuallyAddFile(file, media.url);
          }
        });
      }
    },
    removeFile(file, error, xhr) {
      if (file.size > 1024 * 1024 * 2) {
        this.$store.dispatch(
          "user/setSnack",
          "Upto 2MB File size is allowed"
        );
        this.$store.dispatch("user/setType", "error");
      }
      this.deletePicture(file);
    },
    async deletePicture(file) {
      try {
        if (file) {
          let mediaId = this.media.filter((media) => {
            if (media.mediaType == "image" && media.name == file.name) {
              return media._id;
            }
          });
          if (mediaId.length > 0) {
            const response = await MediaService.deleteMedia({
              id: mediaId[0]._id,
              body: {
                moduleType: "channels",
                moduleId: this.communityId,
              },
            });
            this.getMedia();
            if (response) {
              this.$store.dispatch(
                "user/setSnack",
                "Community image deleted successfully!"
              );
              this.$store.dispatch("user/setType", "info");
            }
          }
        }
      } catch (error) {
        this.$store.dispatch("user/setSnack", error);
        this.$store.dispatch("user/setType", "error");
      }
    },
    async validateSave() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          this.community = {...this.community,users:this.communityGroup.users}
          const response = await CommunityService.create(this.community);
          this.loading = false;
          this.isEdit = true;
          if (response) {
            this.communityId = response.data.id;
           await  this.createGroup();
        
          }
        } catch (error) {
          this.$store.dispatch("user/setSnack", error);
          this.$store.dispatch("user/setType", "error");
          this.loading = false;
        }
      }
    },
    async validateUpdate() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
            this.community = {...this.community,users:this.communityGroup.users}
          const response = await CommunityService.update({
            id: this.communityId ? this.communityId : this.$route.params.id,
            object: this.community,
          });
          this.loading = false;
          if (response) {
            this.communityId = response.data.id;
           await this.updateGroup();
          }
        } catch (error) {
          this.$store.dispatch("user/setSnack", error);
          this.$store.dispatch("user/setType", "error");
          this.loading = false;
        }
      }
    },
    async saveAndNext() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          this.loading = false;
          this.$store.dispatch("user/setSnack", `Community ${(this.isEdit) ? 'updated' : 'added'} successfully!`);
          this.$store.dispatch("user/setType", "info");
          this.$router.push("/community");
        } catch (error) {
          this.$store.dispatch("user/setSnack", error);
          this.$store.dispatch("user/setType", "error");
          this.loading = false;
        }
      }
    },
    cancel() {
      this.$router.push("/community");
    },
    async createGroup() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          setTimeout(async () => {
            const response = await CommunityService.createGroup({
              channelId: this.communityId ? this.communityId : this.$route.params.id,
              name: this.communityGroup.name,
              users: this.communityGroup.users,
            });
            if (response) {
              this.$store.dispatch('user/setSnack', 'Community & Group created successfully.');
              this.$store.dispatch('user/setType', 'info');
              this.loading = false;
              this.e1 = 2;
            }
          }, 2000);
        } catch (error) {
          this.$store.dispatch("user/setSnack", error);
          this.$store.dispatch("user/setType", "error");
          this.loading = false;
        }
      }
    },
    async updateGroup() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          if (this.communityGroup && this.communityGroup.roomId) {
            const response = await CommunityService.editGroup({
              id: this.communityGroup.roomId,
              object: {
                name: this.communityGroup.name,
                users: this.communityGroup.users,
              }
            });
            if (response) {
              this.$store.dispatch('user/setSnack', 'Community & Group details edited successfully.');
              this.$store.dispatch('user/setType', 'info');
              this.loading = false;
              this.e1 = 2;
            }
          } else {
            this.createGroup();
          }
        } catch (error) {
          this.$store.dispatch("user/setSnack", error);
          this.$store.dispatch("user/setType", "error");
          this.loading = false;
        }
      }
    },
    async getAllUsers() {
      this.usersListLoading = true;
      const params = {
        limit: parseInt(this.perPage, 10),
        skip:
          parseInt(this.page, 10) * parseInt(this.perPage, 10) - parseInt(this.perPage, 10),
        search: this.search,
      };
      const response = await CommunityService.getUsers(params);
        this.usersList = response.data.data;
      // for (let i = 0; i < userArr.length; i++) {
      //   if (userArr[i].email === this.user.email) {
      //     userArr.splice(i, 1);
      //   }
      // }
      // this.usersList = [];
      // Object.values(userArr).forEach((element) => {
      //   // console.log('element', element);
      //   this.usersList.push(element);
      // });
      this.usersListLoading = false;
    },
    selectAllUsers(event) {
      this.communityGroup.users = [];
      if (event) {
        this.usersList.forEach((obj) => {
          this.communityGroup.users.push(obj);
        });
      }
    },
    searchUsers() {
      this.items = [];
      this.page = 1;
      this.infiniteId += 1;
    },
    // selectedElement(item) {
    //   const isPresent = this.selections.some(el => el._id === item._id);
    //   if (!isPresent) {
    //     this.selections.push(item);
    //   }
    // },
    // removeElement(id) {
    //   this.selections = this.selections.filter(el => el._id !== id);
    // },
  },
};
</script>